// Tipos para documentos del proveedor
export interface DocumentoProveedor {
  id: string;
  file: File;
  preview: string;
  nombre: string;
  tamaño: number;
  tipo: string;
  categoria: 'camara_comercio' | 'certificacion_bancaria' | 'otro';
}

// Datos para crear un proveedor
export interface CrearProveedorData {
  codigo: string;
  nombre: string;
  nit: string;
  email?: string;
  telefono?: string;
  direccion?: string;
  ciudad?: string;
  pais?: string;
  notas?: string;
  documentos?: DocumentoProveedor[];
}

// Errores de validación del formulario
export interface ProveedorFormErrors {
  codigo?: string;
  nombre?: string;
  nit?: string;
  email?: string;
  telefono?: string;
  direccion?: string;
  ciudad?: string;
  pais?: string;
  notas?: string;
  documentos?: string;
}

// Proveedor completo (para futuras funcionalidades)
export interface ProveedorCompleto {
  id: number;
  codigo: string;
  nombre: string;
  nit: string;
  email?: string;
  telefono?: string;
  direccion?: string;
  ciudad?: string;
  pais: string;
  notas?: string;
  documentos?: DocumentoProveedor[];
  activo: boolean;
  createdAt: Date;
  updatedAt: Date;
}

// === NUEVOS TIPOS PARA LISTADO Y GESTIÓN ===

// Proveedor para mostrar en tabla (versión simplificada)
export interface ProveedorListaItem {
  id: number;
  codigo: string;
  nombre: string;
  nit: string;
  ciudad?: string;
  createdAt: Date;
  activo: boolean;
  cantidadDocumentos: number;
}

// Configuración de paginación
export interface ConfiguracionPaginacion {
  pagina: number;
  registrosPorPagina: number;
  totalRegistros: number;
  totalPaginas: number;
}

// Opciones de registros por página
export const OPCIONES_REGISTROS_POR_PAGINA = [5, 10, 25, 50, 100] as const;
export type RegistrosPorPagina = typeof OPCIONES_REGISTROS_POR_PAGINA[number];

// Filtros para búsqueda de proveedores
export interface FiltrosProveedoresData {
  busqueda: string; // Búsqueda general (código, nombre, NIT)
  ciudad: string;
  activo?: boolean;
  fechaDesde?: Date;
  fechaHasta?: Date;
}

// Ordenamiento de la tabla
export type CampoOrdenamiento = 'codigo' | 'nombre' | 'nit' | 'ciudad' | 'createdAt';
export type DireccionOrdenamiento = 'asc' | 'desc';

export interface OrdenamientoTabla {
  campo: CampoOrdenamiento;
  direccion: DireccionOrdenamiento;
}

// Response de la API para listado paginado
export interface RespuestaListaProveedores {
  proveedores: ProveedorListaItem[];
  paginacion: ConfiguracionPaginacion;
  filtrosAplicados: FiltrosProveedoresData;
  ordenamiento: OrdenamientoTabla;
}

// Acciones disponibles en la tabla
export type AccionProveedor = 'editar' | 'eliminar' | 'ver' | 'duplicar';

// Parámetros para consultar la lista
export interface ParametrosListaProveedores {
  paginacion: Pick<ConfiguracionPaginacion, 'pagina' | 'registrosPorPagina'>;
  filtros: FiltrosProveedoresData;
  ordenamiento: OrdenamientoTabla;
}

// Estado del componente de lista
export interface EstadoListaProveedores {
  proveedores: ProveedorListaItem[];
  cargando: boolean;
  error: string | null;
  configuracion: ConfiguracionPaginacion;
  filtros: FiltrosProveedoresData;
  ordenamiento: OrdenamientoTabla;
}

// Categorías de documentos disponibles
export const CATEGORIAS_DOCUMENTOS = {
  camara_comercio: 'Cámara de Comercio',
  certificacion_bancaria: 'Certificación Bancaria',
  otro: 'Otro Documento',
} as const;

export type CategoriaDocumento = keyof typeof CATEGORIAS_DOCUMENTOS; 